<template>
  <div>
    <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
    <span class="sr-only">Loading...</span>
  </div>
</template>

<script>
export default {
  name: 'Loader',
};
</script>

<style lang="scss" scoped>
  i {
    margin-top: 50%;
    color: #673AB7;
  }
</style>



// WEBPACK FOOTER //
// src/components/loader/Loader.vue